var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8358 19.4876C54.9457 21.5974 56.0006 24.3629 56.0006 27.1274C56.0006 29.892 54.9457 32.6574 52.8358 34.7673L44.5844 43.0188L34.6904 37.633L29.3047 27.7391L37.5562 19.4876C41.7758 15.2678 48.616 15.2678 52.8358 19.4876Z",
    fill: "url(#paint0_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.837 19.4879C54.9469 21.5978 56.0018 24.3632 56.0018 27.1278C56.0018 29.8923 54.9469 32.6578 52.837 34.7676L44.5856 43.0191L34.6916 37.6334L33.0508 34.6185L50.1478 17.5215C51.1406 18.0339 52.0478 18.6973 52.837 19.4879Z",
    fill: "url(#paint1_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5657 37.0382L44.5831 43.0182L34.6899 37.6331L29.3047 27.7399L35.2848 21.7573L50.5657 37.0382Z",
    fill: "url(#paint2_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3031 27.7393L44.5828 43.0189L36.3313 51.2704C32.1115 55.4902 25.2714 55.4902 21.0516 51.2704C18.9418 49.1606 17.8867 46.3951 17.8867 43.6306C17.8867 40.866 18.9416 38.1006 21.0516 35.9907L29.3031 27.7393Z",
    fill: "url(#paint3_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3031 27.7393L44.5828 43.0189L36.3313 51.2704C32.1115 55.4902 25.2714 55.4902 21.0516 51.2704C18.9418 49.1606 17.8867 46.3951 17.8867 43.6306C17.8867 40.866 18.9416 38.1006 21.0516 35.9907L29.3031 27.7393Z",
    fill: "url(#paint4_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 36.4455L35.8787 51.6992C36.0343 51.5606 36.1859 51.4176 36.3334 51.2704L44.5849 43.0189L29.3052 27.7393L21.0537 35.9907C20.9065 36.1382 20.7636 36.2899 20.625 36.4455Z",
    fill: "url(#paint5_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.616 33.0513L44.5837 43.0189L36.3322 51.2704C32.1124 55.4902 25.2723 55.4902 21.0525 51.2704C20.2618 50.4812 19.5983 49.574 19.0859 48.5812L34.616 33.0513Z",
    fill: "url(#paint6_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5565 19.4876L31.6406 25.4035L46.9203 40.6832L52.8362 34.7673C54.946 32.6574 56.0011 29.892 56.001 27.1274C56.001 24.3629 54.946 21.5974 52.8362 19.4876C48.6164 15.2678 41.7762 15.2678 37.5565 19.4876Z",
    fill: "url(#paint7_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9491 36.6796C32.8393 38.7894 30.0738 39.8444 27.3093 39.8444C24.5447 39.8444 21.7793 38.7894 19.6694 36.6796L11.418 28.4281L16.8037 18.5342L26.6977 13.1484L34.9491 21.3999C39.1689 25.6197 39.1689 32.4598 34.9491 36.6796Z",
    fill: "url(#paint8_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9491 36.6798C32.8393 38.7897 30.0738 39.8446 27.3093 39.8446C24.5447 39.8446 21.7793 38.7897 19.6694 36.6798L11.418 28.4284L16.8037 18.5344L19.8185 16.8936L36.9156 33.9906C36.4032 34.9834 35.7398 35.8906 34.9491 36.6798Z",
    fill: "url(#paint9_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.696 13.1487L11.4163 28.4283L3.16485 20.1769C-1.05495 15.9571 -1.05495 9.11698 3.16485 4.89719C5.27469 2.78734 8.04013 1.73231 10.8047 1.73242C13.5693 1.73242 16.3347 2.78734 18.4445 4.8973L26.696 13.1487Z",
    fill: "url(#paint10_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.384 18.4607L11.4163 28.4284L3.16485 20.1769C-1.05495 15.9571 -1.05495 9.11702 3.16485 4.89723C3.95407 4.10648 4.86128 3.44306 5.85405 2.93066L21.384 18.4607Z",
    fill: "url(#paint11_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9456 21.4002L29.0297 15.4844L13.75 30.7641L19.6659 36.6799C21.7757 38.7898 24.5412 39.8448 27.3057 39.8447C30.0703 39.8447 32.8357 38.7898 34.9456 36.6799C39.1654 32.4601 39.1654 25.62 34.9456 21.4002Z",
    fill: "url(#paint12_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9456 21.4002L29.0297 15.4844L13.75 30.7641L19.6659 36.6799C21.7757 38.7898 24.5412 39.8448 27.3057 39.8447C30.0703 39.8447 32.8357 38.7898 34.9456 36.6799C39.1654 32.4601 39.1654 25.62 34.9456 21.4002Z",
    fill: "url(#paint13_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9491 36.6791C32.8393 38.7889 30.0738 39.844 27.3093 39.844C24.5447 39.844 21.7793 38.7891 19.6694 36.6791L11.418 28.4276L21.3856 18.46L36.9156 33.9899C36.4032 34.9827 35.7399 35.8899 34.9491 36.6791Z",
    fill: "url(#paint14_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6413 22.3783C44.3889 22.3783 49.0482 17.719 49.0482 11.9714C49.0482 6.22379 44.3889 1.56445 38.6413 1.56445C32.8937 1.56445 28.2344 6.22379 28.2344 11.9714C28.2344 17.719 32.8937 22.3783 38.6413 22.3783Z",
    fill: "url(#paint15_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4397 6.40716L33.0788 20.7681C31.7782 19.942 30.6724 18.8364 29.8516 17.5357L44.2099 3.1748C45.5114 4.00126 46.6143 5.105 47.4397 6.40716Z",
    fill: "url(#paint16_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2344 11.9711C28.2344 17.7187 32.8936 22.3781 38.6413 22.3781C44.389 22.3781 49.0482 17.7187 49.0482 11.9711C49.0482 11.6834 49.036 11.3986 49.0131 11.1167H28.2695C28.2463 11.4009 28.2345 11.686 28.2344 11.9711Z",
    fill: "url(#paint17_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6445 1.56445C37.974 1.56445 37.3187 1.62866 36.6836 1.74973V22.1929C37.3299 22.3162 37.9865 22.3782 38.6445 22.3782C44.392 22.3782 49.0514 17.7188 49.0514 11.9713C49.0514 6.22372 44.3921 1.56445 38.6445 1.56445Z",
    fill: "url(#paint18_linear_858_374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9587 4.56982L31.2422 19.2863C33.1288 21.1952 35.748 22.3783 38.6438 22.3783C44.3914 22.3783 49.0507 17.7189 49.0507 11.9713C49.0506 9.07553 47.8675 6.45632 45.9587 4.56982Z",
    fill: "url(#paint19_linear_858_374)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_858_374",
    x1: 41.2254,
    y1: 25.9704,
    x2: 47.9973,
    y2: 32.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DAF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_858_374",
    x1: 42.2122,
    y1: 26.9563,
    x2: 51.7972,
    y2: 36.5413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_858_374",
    x1: 43.8349,
    y1: 32.539,
    x2: 35.9744,
    y2: 32.2342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_858_374",
    x1: 26.4596,
    y1: 40.735,
    x2: 33.2314,
    y2: 47.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FA5964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#EF3D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_858_374",
    x1: 31.2471,
    y1: 43.7048,
    x2: 30.8206,
    y2: 35.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_858_374",
    x1: 33.2147,
    y1: 39.3203,
    x2: 39.329,
    y2: 34.9783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_858_374",
    x1: 29.2075,
    y1: 43.482,
    x2: 35.9892,
    y2: 50.2637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_858_374",
    x1: 46.9604,
    y1: 28.5727,
    x2: 55.7626,
    y2: 30.0497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_858_374",
    x1: 28.4177,
    y1: 25.002,
    x2: 21.6459,
    y2: 31.7738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_858_374",
    x1: 27.4323,
    y1: 25.9876,
    x2: 17.8472,
    y2: 35.5728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_858_374",
    x1: 16.0536,
    y1: 7.89986,
    x2: 4.85808,
    y2: 19.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#B6E4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#99D69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#6BC18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#2CA36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02905D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_858_374",
    x1: 9.44243,
    y1: 17.0398,
    x2: 5.79652,
    y2: 24.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#026841",
    stopOpacity: 0.033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#026841",
    stopOpacity: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#026841",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#026841",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#026841",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_858_374",
    x1: 25.8119,
    y1: 30.7368,
    x2: 24.335,
    y2: 39.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_858_374",
    x1: 25.3358,
    y1: 27.5275,
    x2: 31.6274,
    y2: 40.0221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_858_374",
    x1: 23.2197,
    y1: 34.1306,
    x2: 21.2274,
    y2: 40.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FAC602",
    stopOpacity: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#FAC80B",
    stopOpacity: 0.067
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FACC1A",
    stopOpacity: 0.151
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FBD12E",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#FBD748",
    stopOpacity: 0.419
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#FCDF69",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDE88E",
    stopOpacity: 0.819
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_858_374",
    x1: 33.0107,
    y1: 6.34075,
    x2: 44.6884,
    y2: 18.0185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_858_374",
    x1: 40.1168,
    y1: 13.4437,
    x2: 36.4743,
    y2: 9.80118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_858_374",
    x1: 38.6413,
    y1: 14.0674,
    x2: 38.6413,
    y2: 24.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2740B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#263FAE",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#253DAB",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#233BA4",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#21379B",
    stopOpacity: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#1E3290",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#1A2C82",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_858_374",
    x1: 40.7876,
    y1: 11.9713,
    x2: 51.1469,
    y2: 11.9713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2740B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#263FAE",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#253DAB",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#233BA4",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#21379B",
    stopOpacity: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#1E3290",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#1A2C82",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_858_374",
    x1: 42.2401,
    y1: 15.5676,
    x2: 47.3783,
    y2: 20.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#0BAAF1",
    stopOpacity: 0.025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#15AEF2",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#26B5F3",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#3DBFF5",
    stopOpacity: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#5ACBF7",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#7EDAF9",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E6FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_858_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineicon);
export default __webpack_public_path__ + "static/media/medicineicon.0860b2a5ac724cdb1a3bc46f4549a9e0.svg";
export { ForwardRef as ReactComponent };